import { FridgeBottomIcon } from './FridgeBottomIcon';

/**
 * author: Simran
 * id F88B80D0-1521-48F8-BC15-94BA5F14BFC1
 * name fridge-bottom
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-bottom.svg
 * tags
 * - Home Automation 
 */
export const RefrigeratorBottomIcon = FridgeBottomIcon;
export default RefrigeratorBottomIcon